import { render, staticRenderFns } from "./ServerDaily.vue?vue&type=template&id=036f3965"
import script from "./ServerDaily.vue?vue&type=script&lang=js"
export * from "./ServerDaily.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports